<template>
<div :class="`chart top-rated md-layout-item md-size-${width} md-large-size-${width} md-medium-size-${width} md-small-size-100`">
    <div>
        <h2>{{label}}</h2>

        <div class="chart-inner">
            <div :key="index" v-for="(rate, index) in rates">
                <div class="activity-rate">
                    <div class="icon-wrapper">
                        <img v-if="rate.image" :src="rate.image" class="icon" height="64"/>
                    </div>
                    <div class="">
                        <div class="title">{{rate.title}}</div>
                        <star-rating
                                :read-only="true"
                                :rating="parseFloat(rate.avg_rate)"
                                :increment="1"
                                :max-rating="5"
                                :star-size="16"
                                :round-start-rating="false"
                                :show-rating="false"
                                :rounded-corners="true"
                                active-color="#ffa300"
                                inactive-color="#ffffff"
                                :border-width=4
                                border-color="#ffa300"
                        >
                        </star-rating>
                    </div>
                </div>
            </div>
        </div>
        <div class="spacer">&nbsp;</div>
    </div>
</div>
</template>

<script>
  import StarRating from 'vue-star-rating'

  export default {
    name: "TopRatedStrategies",
    computed: {},
    components: {
      StarRating
    },
    mounted() {
    },
    data() {
      let rates = window.drupalSettings.controller.graphs.TopRatedStrategies.data

      return {
        label: window.drupalSettings.controller.graphs.TopRatedStrategies.label,
        width: window.drupalSettings.controller.graphs.TopRatedStrategies.width || 33,
        rates
      };
    },

    methods: {}
  };
</script>
<style lang="scss" scoped>

    .title {
        font-family: "Source Sans Pro" !important;
        font-size: 14px;
        color: rgb(60, 60, 60);
    }

    .activity-rate {
        display: flex;
        background-color: rgba($color: #ffffff, $alpha: 0.1);
        border-radius: 10px;
        margin-bottom: 10px;
        padding: 10px;
        color: #ffffff;
        .vue-star-rating-star {
            &:hover {
                opacity: 0.6;
            }
        }
    }
    .icon-wrapper {
        margin-right: 15px;
    }

    .icon {
        background: #3c9ebb;
        border-radius: 10px;
        height: 64px;
        max-width: 64px;
        &:hover {
            opacity: 0.6;
            cursor: pointer;
        }
    }

</style>
